import React from "react";
import { Link } from "react-router-dom";
import { DELHI_EVENT_ID } from "./eventShared";

// Shown for old AKIBA Maid Cafe links: the cafe is now an add-on of the Delhi ticket.
const CafeMoved = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#F5F3FF] px-6 text-center" data-testid="cafe-moved">
    <p className="text-xl font-extrabold text-gray-900">Maid Cafe is now part of the Ōta TOKYO Delhi ticket</p>
    <p className="max-w-sm text-sm text-gray-600">
      Pick your pass, then add a Maid Cafe session in the same checkout.
    </p>
    <Link
      to={`/events/checkout?event=${DELHI_EVENT_ID}`}
      className="rounded-xl bg-gradient-to-r from-[#3969E7] to-[#7D2AE7] px-6 py-3 font-bold text-white"
      data-testid="cafe-moved-link"
    >
      Go to Delhi tickets
    </Link>
  </div>
);

export default CafeMoved;
